module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'nav-panel/base' && templateVars.config ?
				templateVars.config :
				{
	"animation": {
		"show": {
			"effect": "transition.slideRightBigIn",
			"duration": 200
		},
		"hide": {
			"effect": "transition.slideRightBigOut",
			"duration": 200
		}
	},
	"burgerTitle": {
		"open": "Открыть меню",
		"close": "Закрыть меню"
	}
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/nav-panel/.variant/base/config.yaml
// module id = 78
// module chunks = 0